export default "__VITE_ASSET__c63a58d4__"